<template>
  <div id="app">
    <router-view v-if="isRoutreAlive" ></router-view>
  </div>
</template>
<script>
export default {
  name:'app',
  provide()
  {
    return {
      reload:this.reload
    }
  },
  data(){
    return {
      isRoutreAlive:true,
    }
  },
  methods:{
    reload()
    {
      this.isRoutreAlive = false;
      this.$nextTick(function(){
        this.isRoutreAlive = true;
      });
    }
  },
}
</script>

<style lang="scss">
</style>
